"use client";

import { UnhandledRunTimeError as DSUnhandledRunTimeError } from "@offstreetparking/design-system/feedback";
import { DEFAULT_LOCALE } from "@offstreetparking/domain/i18n";
import { buildSupportUrl } from "@offstreetparking/portal-flow/utils/support-url";

type UnhandledRunTimeErrorProps = {
	eventId: string | null;
	error: unknown;
	parkerId?: number;
	onReload: () => void;
};

export const UnhandledRunTimeError = ({ eventId, error, parkerId, onReload }: UnhandledRunTimeErrorProps) => {
	// Also rendered by global-error, outside the Lingui provider, so this screen is English-only.
	const supportUrl = buildSupportUrl({ locale: DEFAULT_LOCALE, parkerId });
	return (
		<DSUnhandledRunTimeError
			eventId={eventId}
			error={error}
			onReload={onReload}
			i18n={{
				title: "Something went wrong",
				message: (
					<>
						Please refresh and retry. If the issue persists, please{" "}
						<a
							className="text-neutral-faded underline"
							href={supportUrl}
							target="_blank"
							rel="noopener noreferrer"
						>
							contact us
						</a>
						.
					</>
				),
				reloadButton: "Reload",
				copied: "Copied!",
				copyToClipboard: "Copy to clipboard",
				copyFailed: "Couldn't copy to clipboard",
				copyBlocked:
					"Your browser didn't allow access to the clipboard. Check the browser's permissions for this site and try again.",
			}}
		/>
	);
};
